var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfersColor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 12.5C18.3333 15.725 15.725 18.3333 12.5 18.3333L13.375 16.875",
    stroke: "#263BD4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 7.50001C1.6665 4.27501 4.27484 1.66667 7.49984 1.66667L6.62484 3.12501",
    stroke: "#263BD4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 3.50001V3.59167C18.3333 3.82501 18.15 4.00834 17.9167 4.00834H10.4167C10.1833 4.00834 10 3.82501 10 3.59167V3.50001C10 2.03334 10.3667 1.66667 11.85 1.66667H16.4833C17.9667 1.66667 18.3333 2.03334 18.3333 3.50001Z",
    fill: "#263BD4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4167 4.84166C10.1833 4.84166 10 5.02499 10 5.25833V6.09166V6.91666C10 8.38333 10.3667 8.74999 11.85 8.74999H16.4833C17.9667 8.74999 18.3333 8.38333 18.3333 6.91666V6.09166V5.25833C18.3333 5.02499 18.15 4.84166 17.9167 4.84166H10.4167Z",
    fill: "#263BD4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 13.0833V13.175C9.99984 13.4083 9.8165 13.5917 9.58317 13.5917H2.08317C1.84984 13.5917 1.6665 13.4083 1.6665 13.175V13.0833C1.6665 11.6167 2.03317 11.25 3.5165 11.25H8.14984C9.63317 11.25 9.99984 11.6167 9.99984 13.0833Z",
    fill: "#263BD4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08317 14.425C1.84984 14.425 1.6665 14.6083 1.6665 14.8417V15.675V16.5C1.6665 17.9667 2.03317 18.3333 3.5165 18.3333H8.14984C9.63317 18.3333 9.99984 17.9667 9.99984 16.5V15.675V14.8417C9.99984 14.6083 9.8165 14.425 9.58317 14.425H2.08317Z",
    fill: "#263BD4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfersColor);
export default __webpack_public_path__ + "static/media/TransfersColor.4ac3ac912158a9fa7d1c78f5e304951d.svg";
export { ForwardRef as ReactComponent };